/* eslint-disable @typescript-eslint/naming-convention */
import React, { useCallback, useEffect, useState } from "react";
import { Create, SimpleForm, useCreate, useNotify, useRedirect } from "react-admin";
import axios from "axios";

// Types
import { CreateUsersProps } from "../../types/users";

// Providers
import { organizationsProvider } from "../../providers/organizations";

// Components
import { UserForm } from "./UserForm";

export const CreateComponent: React.FC = () => {
  const notify = useNotify();
  const redirect = useRedirect();
  const [create] = useCreate();
  const [initialData, setInitialData] = useState<CreateUsersProps>({
    first_name: "",
    last_name: "",
    email: "",
    members: [],
    organizations: [],
  });

  const postSave = async (dataForm: any) => {
    const { first_name, last_name, email, members } = dataForm as CreateUsersProps;

    const membersWithIds = members.map((item) => {
      const { organization, role } = item;
      return { organization: organization.id, role };
    });
    const data = { first_name, last_name, email, members: membersWithIds };

    try {
      await create("users", { data }, { returnPromise: true });
      notify("Successfully created user", { type: "success" });
      redirect("list", "users");
    } catch (error) {
      if (axios.isAxiosError(error)) {
        notify(error.response?.data.message, { type: "error" });
      }
      if (error instanceof Error) {
        notify(error.message, { type: "error" });
      }
    }
  };

  const fetchData = useCallback(async () => {
    const response = await organizationsProvider.getMany();

    if (response) {
      setInitialData((oldValue) => ({ ...oldValue, organizations: response }));
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return (
    <Create redirect={"list"}>
      <SimpleForm mode="onBlur" reValidateMode="onBlur" onSubmit={postSave} defaultValues={initialData}>
        <UserForm />
      </SimpleForm>
    </Create>
  );
};
